<script setup lang="ts">
import {useColorModes} from '@coreui/vue';
import {CContainer} from "@coreui/vue/dist/esm/components/grid";
import {CHeader, CHeaderNav, CHeaderToggler} from "@coreui/vue/dist/esm/components/header";
import CIcon from "@coreui/icons-vue";
import {cilColumns, cilContrast, cilMenu, cilMoon, cilSun} from '@coreui/icons';
import {CNavItem, CNavLink} from "@coreui/vue/dist/esm/components/nav";
import {CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle} from "@coreui/vue/dist/esm/components/dropdown";
import {AppHeaderDropdownAccnt, AppSeletorCartorio} from "~/components/ui";
import AppBreadcrumb from "~/components/layout/AppBreadcrumb";
import {computed} from "vue";
import {useCartorioCor} from '~/composables';

const store = useStore();
const { sidebarVisible } = storeToRefs(store);
const headerClassNames = ref('mb-4 p-0');
const { colorMode, setColorMode } = useColorModes('coreui-free-vue-admin-template-theme')
const {
  isAuthenticated,
  getCurrentUser,
  getCurrentCartorio,
  isAdmin,
  clearAuthData
} = useAuthStorage()

const { getCurrentCartorioCor } = useCartorioCor()
const cartorioCor = computed(() => getCurrentCartorioCor())

</script>

<template>
  <CHeader
      position="sticky"
      :class="headerClassNames"
      :style="`background-color: ${cartorioCor};`"
  >

    <CContainer class="border-bottom px-4" fluid>
<!--      <CHeaderToggler-->
<!--          v-c-tooltip="'Alternar Sidebar'"-->
<!--          style="margin-inline-start: -14px"-->
<!--          @click="sidebarVisible = !sidebarVisible"-->
<!--      >-->
<!--        <CIcon :icon="cilMenu" size="lg" />-->
<!--      </CHeaderToggler>-->

      <AppSeletorCartorio />

      <CHeaderNav>
        <CNavItem class="nav-item">
          <CNavLink class="text-white">
            <CIcon
                v-c-tooltip="'Controle de Processos'"
                :icon="cilColumns"
                size="lg"
                title="Controle de processos"
            />
          </CNavLink>
        </CNavItem>
      </CHeaderNav>

      <CHeaderNav>
        <li class="nav-item py-1e">
          <div class="vr h-100 mx-2 text-body text-opacity-75" />
        </li>
        <CDropdown variant="nav-item" placement="bottom-end">
          <CDropdownToggle v-c-tooltip="'Mudar modo de cor'" :caret="false" class="text-white">
            <CIcon v-if="colorMode === 'dark'" :icon="cilMoon" size="lg" />
            <CIcon v-else-if="colorMode === 'light'" :icon="cilSun" size="lg" />
            <CIcon v-else :icon="cilContrast" size="lg" />
          </CDropdownToggle>
          <CDropdownMenu>

            <CDropdownItem
                v-c-tooltip="'Modo Claro'"
                :active="colorMode === 'light'"
                class="d-flex align-items-center"
                component="button"
                type="button"
                @click="setColorMode('light')"
            >
              <CIcon class="me-2" :icon="cilSun" size="lg" /> Modo Claro
            </CDropdownItem>

            <CDropdownItem
                v-c-tooltip="'Modo Escuro'"
                :active="colorMode === 'dark'"
                class="d-flex align-items-center"
                component="button"
                type="button"
                @click="setColorMode('dark')"
            >
              <CIcon class="me-2" :icon="cilMoon" size="lg" /> Modo Escuro
            </CDropdownItem>

            <CDropdownItem
                v-c-tooltip="'Auto'"
                :active="colorMode === 'auto'"
                class="d-flex align-items-center"
                component="button"
                type="button"
                @click="setColorMode('auto')"
            >
              <CIcon class="me-2" :icon="cilContrast" size="lg" /> Auto
            </CDropdownItem>

          </CDropdownMenu>
        </CDropdown>

        <li class="nav-item py-1">
          <div class="vr h-100 mx-2 text-body text-opacity-75" />
        </li>

        <AppHeaderDropdownAccnt v-c-tooltip="'Conta do Usuário'" />

      </CHeaderNav>

    </CContainer>

    <CContainer class="px-4 bg-primary" fluid>
      <AppBreadcrumb v-c-tooltip="'Breadcrumb'" />
    </CContainer>

  </CHeader>
</template>